var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPizzaSlice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2.8A2.716,2.716,0,0,0,20.3.176L3.155,6.929a4.976,4.976,0,0,0-3,5.824,15.855,15.855,0,0,0,11.094,11.1h0a4.983,4.983,0,0,0,5.825-3.009L23.832,3.672A2.71,2.71,0,0,0,23.2.8ZM11.746,21.911A13.8,13.8,0,0,1,2.09,12.254a2.949,2.949,0,0,1,1.265-3.18A11.987,11.987,0,0,0,14.924,20.646,2.947,2.947,0,0,1,11.746,21.911Zm4.027-3.227c-6.191-.1-10.355-4.265-10.456-10.457L21.01,2.047a.717.717,0,0,1,.771.17.7.7,0,0,1,.181.747L21.3,4.645c-5.758-1.98-8.942,6.209-3.413,8.668Zm2.847-7.232a2.654,2.654,0,0,1,1.943-4.935Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11,9a2,2,0,0,0,0,4A2,2,0,0,0,11,9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizzaSlice);
export default __webpack_public_path__ + "static/media/pizza-slice.8cf8c7704103f8164163c487150c31d9.svg";
export { ForwardRef as ReactComponent };